/** @jsx jsx */
import { Box, Container, Grid, Heading, jsx } from 'theme-ui'
import PackAwardsCard from '~/components/Pack/Card/Awards'

const AwardListByPack = ({ packs, title, isTrade }) => {
  return (
    <Box mt={7} pb={[8, null, 10]}>
      <Container>
        <Heading as="h2" variant="title2" mb={5} sx={{ textAlign: 'center' }}>
          {title}
        </Heading>
        <Grid columns={[1, 2, 3]}>
          {packs.map(
            (pack, index) =>
              pack.awards && (
                <Box key={`award-pack-${index}`}>
                  <PackAwardsCard pack={pack} isTrade={isTrade} />
                </Box>
              )
          )}
        </Grid>
      </Container>
    </Box>
  )
}

export default AwardListByPack
